import {Component, Input, ViewChild} from '@angular/core';
import {PhoneNumberListComponent} from '../phone-number-list/phone-number-list.component';
import {NameValueListType} from '@app/services/gt-configuration.service';

@Component({
  selector: 'gt-whitelist',
  templateUrl: './whitelist.component.html',
  styleUrls: ['./whitelist.component.scss']
})
export class WhitelistComponent {
  @Input() listType: NameValueListType;
  @Input() orgId: string;
  @Input() login: string;
  @Input() canEdit = true;
  @ViewChild(PhoneNumberListComponent, {static: true}) phoneNumberList: PhoneNumberListComponent;
}
